export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      //Management
      {title: "Users", url: "/management/user", icon: "UserIcon", is_bookmarked: true},
      {title: "Customer", url: "/management/customer", icon: "ListIcon", is_bookmarked: true},
    ]
  }
}
